import * as React from 'react';

import './ImportantPoints.css';

export class ImportantPoints extends React.PureComponent {
    render() {
        return (
            <div
                data-testid="important-points"
                className="points-background">
                <div className="points-container">

                    <h3 className="points-header" data-testid="points-header"><strong>Important points to note:</strong></h3>
                    <h4><strong>What happens next</strong></h4>
                    <ul>
                        <li>
                            You will receive 2 emails from us, a confirmation email and your receipt.
                        </li>
                        <li>
                            Remember to bring your Driving Licence or Learner's Permit with you for all lessons.
                        </li>
                    </ul>
                    <h4><strong>Free Accompanied Driver Cover</strong></h4>
                    <ul>
                        <li> 
                            The policyholder must activate the insurance by contacting Aviva Direct or 
                            their Aviva broker within 7 days of their first driving lesson, the pupil is then 
                            entitled to 6 months Free Accompanied Driver Cover on an existing Aviva private car
                            insurance policy.
                        </li>
                        <li>
                            The pupil will need to complete their first lesson with their Aviva driving instructor 
                            before they can be insured on the policyholder's Aviva car insurance policy. 
                            Their driving instructor will give the pupil a pin number which the policyholder
                            will then use to activate the Free Accompanied Driver Cover.
                        </li>
                        <li>
                            All products must be used within twelve months of the date of purchase. However, where you
                            have availed of the Free Accompanied Driver Cover, all driving lessons must be taken within
                            the 6 months Free Accompanied Driver Cover period.
                        </li>
                        <li>
                            The pupil availing of the 6 months Free Accompanied Driver Cover must be accompanied at all
                            times by the policyholder or a named driver on the policy who holds a full EU licence for
                            a continuous period of two years in respect of the vehicle category
                            (subject to the terms and conditions).
                        </li>
                        <li>
                            Breaks in the Free Accompanied Driver Cover are not permitted.
                        </li>
                        <li>
                            The Free Accompanied Driver Cover must be activated through your insurance provider; Aviva
                            Direct or with your Aviva Broker
                        </li>
                        <li>
                            Your second and subsequent driving lessons
                            must be booked directly with your driving instructor.
                        </li>
                    </ul>
                    <p>
                        “Essential Driver Training (EDT) lessons are designed to complement the usual driving
                        lessons that learners take while learning to drive.” Road Safety Authority
                    </p>
                </div>
            </div>
        );
    }
}
